import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getMemberNumber,
    selectMemberInfo
} from "../../../state/ducks/member/index";
import DatePicker from "react-datepicker";
import tr from "date-fns/locale/tr";
import { clearPaymentList, getPaymentList, deletePayment, getActiveMemberNumber } from '../../../state/ducks/payment';
import { selectPayment } from '../../../state/ducks/payment/selectors';
import { PaymentDetail } from './PaymentDetail';
import $ from 'jquery';

function formKontrol() {
    var uyeNo = $("#uyeno option:selected").text();
    var baslangicTarih = $("#baslangicTarih").val();
    var bitisTarih = $("#bitisTarih").val();
    var durum = 1;
    // kuruş alanı boş ise kuruş 00 olduğu kabul edilir. O sebep ile kontrol dışı.
    // üye numarası seçili mi ?
    if (uyeNo == "Üye Numarası") {
        durum = 0; //SEÇİLMEMİŞ
        $("#uyeno").parent().addClass("t-error");
        $("#uyeno").next().html("<i class='t-icon-error text-danger'></i>");
        $("#uyeNo_hatamesaj").html("Üye Numarasını Seçmelisiniz");
    } else {
        $("#uyeno").parent().removeClass("t-error");
        $("#uyeno").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#uyeNo_hatamesaj").html("");
    }
    // Talimat Tarihi Alanı boş mu kontrol
    if (baslangicTarih == "") {
        durum = 0; // Konu Boş
        $("#baslangicTarih").parent().addClass("t-error");
        $("#baslangicTarih").next().html("<i class='t-icon-error text-danger'></i>");
        $("#baslangicTarih_hatamesaj").html("Bu alan boş bırakılamaz");
    } else {
        $("#baslangicTarih").parent().removeClass("t-error");
        $("#baslangicTarih").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#baslangicTarih_hatamesaj").html("");
    }
    // Açıklama boş mu kontrol
    if (bitisTarih == "") {
        durum = 0; // Mesaj Boş
        $("#bitisTarih").parent().addClass("t-error");
        $("#bitisTarih").next().html("<i class='t-icon-error text-danger'></i>");
        $("#bitisTarih_hatamesaj").html("Bu alan boş bırakılamaz");
    } else {
        $("#bitisTarih").parent().removeClass("t-error");
        $("#bitisTarih").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#bitisTarih_hatamesaj").html("");
    };
    return durum;

}

export class ListPayments extends Component {
    today = new Date();
    state = {
        startDate: new Date(this.today.setMonth(this.today.getMonth() - 1)),
        endDate: new Date(this.today.setMonth(this.today.getMonth() + 2)),
        memberNo: "0",
        payments: [],
        currentPaymentDetail: {}
    }
    componentDidMount() {
        this.props.clearPaymentList();
        this.props.getMemberNumber();
        $(".react-datepicker-wrapper").addClass("form-control");
    }

    getPaymentList = () => {
      
        if (formKontrol() == 1) {
            this.props.clearPaymentList();
            this.props.getPaymentList(this.state.memberNo, this.state.startDate.toLocaleDateString("tr-TR"), this.state.endDate.toLocaleDateString("tr-TR"));
        }
    }
    getPaymentDetail = (item) => {
        this.setState({ currentPaymentDetail: item });
        //this.props.getPaymentDetail(memberNo, paymentId);
    }
    cancelPaymentPopup = (memberNo, paymentId, startDate, isPayforPayment) => {
        this.setState({ currentPaymentDetail: { memberNo, paymentId, startDate, isPayforPayment } });
    }
    cancelPayment = () => {
        this.props.deletePayment(
            this.state.currentPaymentDetail.memberNo,
            this.state.currentPaymentDetail.paymentId,
            this.state.currentPaymentDetail.startDate,
            this.state.startDate.toLocaleDateString("tr-TR"),
            this.state.endDate.toLocaleDateString("tr-TR"),
            this.state.currentPaymentDetail.isPayforPayment
        );
    }
    render() {
        const { payment } = this.props;
        return (
            <>

                <div className="container-fluid">

                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            {/* KUTU 1 */}
                            <div className="row no-gutters t-kutu t-yesilCizgi">
                                <div
                                    className="col bosluk backbottom"
                                    style={{
                                        backgroundImage: 'url("/assets/img/backgrounds/back_bottom_yesil.jpg")'
                                    }}
                                >
                                    {/* içerikler */}
                                    {/* Başlık */}
                                    <div className="row no-gutters pb-4">
                                        <div clss="col-auto">
                                            <i className="t-icon-pen1 icon" />
                                        </div>
                                        <div className="col d-flex flex-column justify-content-center">
                                            <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                                                Ödeme Talimatı
                                            </div>
                                            <span className="altBaslik">Talimatlarım</span>
                                        </div>
                                    </div>
                                    <div className="row no-gutters t-filterArea mb-4">
                                        {/* Başlangıç Tarihi  */}
                                        <div className="col-12 col-lg-4">
                                            <div className="row no-gutters px-1">
                                                <div className="col-12 pb-1">
                                                    <span className="t-icInputTitle pl-3">Başlangıç Tarihi</span>
                                                </div>

                                                <div className="col-12 m-takvim">


                                                    <div className="input-group">
                                                        <div className="input-group-prepend" onClick={e => $(".baslangic_tarihi").focus()}>
                                                            <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                                                                <i className="t-icon-calendar1"></i>
                                                            </span>
                                                        </div>
                                                        <DatePicker className="t-icInput m-datepicker baslangic_tarihi"
                                                            id="baslangicTarih"
                                                            placeholder="Başlangıç Tarihi"
                                                            pattern="^\d{1,2}\/\d{1,2}\/\d{4}$"
                                                            required
                                                            selected={this.state.startDate}
                                                            value={this.state.startDate}
                                                            dateFormat="dd.MM.yyyy"
                                                            locale="tr"
                                                            maxDate={this.state.endDate}

                                                            onChange={e => {
                                                                this.setState({ startDate: e });
                                                            }}
                                                        />

                                                    </div>

                                                </div>
                                                {/* Hata mesajının geleceği alan*/}
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="baslangicTarih_hatamesaj"
                                                />
                                            </div>
                                        </div>
                                        {/* Bitiş Tarihi  */}
                                        <div className="col-12 col-lg-4">
                                            <div className="row no-gutters px-1">
                                                <div className="col-12 pb-1">
                                                    <span className="t-icInputTitle pl-3">Bitiş Tarihi</span>
                                                </div>

                                                <div className="col-12 m-takvim">


                                                    <div className="input-group">
                                                        <div className="input-group-prepend" onClick={e => $(".bitis_Tarih").focus()}>
                                                            <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                                                                <i className="t-icon-calendar1"></i>
                                                            </span>
                                                        </div>
                                                        <DatePicker className="t-icInput m-datepicker bitis_Tarih"
                                                            id="bitisTarih"
                                                            placeholder="Bitiş Tarihi"
                                                            pattern="^\d{1,2}\/\d{1,2}\/\d{4}$"
                                                            required
                                                            selected={this.state.endDate}
                                                            value={this.state.endDate}
                                                            dateFormat="dd.MM.yyyy"
                                                            locale="tr" 
                                                            minDate={this.state.startDate}
                                                            onChange={e => {
                                                                this.setState({ endDate: e });
                                                            }}
                                                        />
                                                    </div>

                                                </div>
                                                {/* Hata mesajının geleceği alan*/}
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="bitisTarih_hatamesaj"
                                                />
                                            </div>
                                        </div>
                                        {/* Üye Numarası  */}
                                        <div className="col-12 col-lg-4">
                                            <div className="row no-gutters px-1">
                                                {/* Üye Numarası*/}
                                                <div className="col-12 pb-1">
                                                    <span className="t-icInputTitle pl-3">Üye Numarası</span>
                                                </div>
                                                {/* üye numaranız*/}
                                                <div className="col-12">
                                                    <div className="t-icInput">
                                                        <div>
                                                            <i className="t-icon-user1" />
                                                        </div>

                                                        <select
                                                            id="uyeno"
                                                            name="uyeno"
                                                            className="custom-select"
                                                            value={this.state.memberNo}
                                                            required
                                                            onChange={e => {
                                                                this.setState({ memberNo: e.target.value });
                                                            }}>
                                                            <option value="0">Üye Numarası</option>
                                                            {payment?.paymentActiveMemberNumbers &&
                                                                payment.paymentActiveMemberNumbers.map(item => {
                                                                    return (
                                                                        <option key={item.id} value={item.id}>
                                                                            {item.adi}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                        <div />
                                                    </div>
                                                </div>
                                                {/* Hata mesajının geleceği alan*/}
                                                <div
                                                    className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                                    id="uyeNo_hatamesaj"
                                                />
                                            </div>
                                        </div>
                                        {/* Button */}
                                        <div className="col-12 d-flex justify-content-center">
                                            <button
                                                className="t-icButtonYesil px-4"
                                                onClick={this.getPaymentList}
                                            >
                                                <span>Getir</span>
                                            </button>
                                        </div>
                                    </div>
                                    {/* Sonuç Satır */}
                                    {

                                        payment?.paymentList &&
                                        payment.paymentList?.map(item => {
                                            return (
                                                <div className="row no-gutters mb-2 t-listArea d-flex align-items-center" key={item.paymentSubscriptionID}>
                                                    <div className="col-12 col-lg-3 satirOzellikleri text-center">
                                                        <span className="maviBaslik">Üyelik No</span>
                                                        <span>{item.uyeNo}</span>
                                                    </div>
                                                    <div className="col-12 d-block d-lg-none">
                                                        <hr style={{ width: "70%" }} />
                                                    </div>
                                                    <div className="col-12 col-lg-3 satirOzellikleri text-center">
                                                        <span className="maviBaslik">Açılma Tarihi</span>
                                                        <span>{item.createDate}</span>
                                                    </div>
                                                    <div className="col-12 d-block d-lg-none">
                                                        <hr style={{ width: "70%" }} />
                                                    </div>
                                                    <div className="col-12 col-lg-3 satirOzellikleri text-center">
                                                        <span className="maviBaslik">Talimat Tarihi</span>
                                                        <span>{item.startDate}</span>
                                                    </div>
                                                    <div className="col-12 d-block d-lg-none">
                                                        <hr style={{ width: "70%" }} />
                                                    </div>
                                                    <div className="col-12 col-lg-3 satirOzellikleri text-center">
                                                        <span className="maviBaslik">Durum</span>
                                                        <span>{item.status}</span>
                                                    </div>
                                                    <div className="col-12">
                                                        <hr />
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center">
                                                        <button
                                                            className="t-icButtonYesil mr-2"
                                                            data-toggle="modal"
                                                            data-target="#aciklama"
                                                            onClick={() => this.getPaymentDetail(item)}
                                                        >
                                                            <span>Detay</span>
                                                            <i className="t-icon-arrow-right2" />
                                                        </button>
                                                        {item.btnVisible == true ?
                                                            (<button
                                                                className="t-icButonTrunucu pl-0 mr-2"
                                                                data-toggle="modal"
                                                                data-target="#iptal"
                                                                onClick={() => this.cancelPaymentPopup(item.uyeNo, item.paymentSubscriptionID, item.startDate, item.isPayforPayment)}
                                                            >
                                                                <i className="t-icon-cancel-circle pr-2" />
                                                                <span>İptal Et</span>
                                                            </button>) : null}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                    {/* Sonuç Satır */}

                                    {/* içerikler BİTTİ */}
                                </div>
                                <div className="col-auto renk" />
                            </div>
                            {/* KUTU 1 BİTTİ */}
                        </div>
                    </div>
                    {/* Duyurlar Baslık*/}
                    {/* duyrular Bitti*/}
                    <div className="row" style={{ height: 30 }} />


                    <div className="modal" data-toggle="modal" id="aciklama" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>

                        <div className="t-modalAreaPaymentDetail" data-toggle="modal" id="id-modal">
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentPaymentDetail " id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "51%" }}>
                                <div
                                    className="t-modalPaymentDetail "
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)" }}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderPaymentDetail ">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(153, 153, 153)" }}
                                            >
                                                Üyelik Numarası : <strong>{this.state.currentPaymentDetail.uyeNo}</strong>
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(153, 153, 153)" }}

                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyPaymentDetail ">
                                            <div
                                                className="col-12"
                                                id="id-modalBody"
                                                style={{ color: "rgb(153, 153, 153)" }}
                                            >
                                                <PaymentDetail detail={this.state.currentPaymentDetail}></PaymentDetail>
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterPaymentDetail ">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(153, 153, 153)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modal" id="iptal" data-toggle="modal" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>

                        <div className="t-modalAreaPaymentDetail" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentPaymentDetail" id="id-modalIptal" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "30%" }}>
                                <div
                                    className="t-modalPaymentDetail"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(241, 90, 42)" }}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderPaymentDetail">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(255, 255, 255)" }}
                                            >

                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(255, 255, 255)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyPaymentDetail">
                                            <div
                                                className="col-12"
                                                id="id-modalBody"
                                                style={{ color: "rgb(255, 255, 255)" }}
                                            >
                                                <div className="w-100 text-center" style={{ fontSize: "14pt" }}>
                                                    <i className="t-icon-question1" style={{ fontSize: "60pt" }} />
                                                    <br />
                                                    <br />
                                                    İptal Etmek İstediğinizden Emin misiniz?
                                                    <hr />
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning rounded-pill px-4"
                                                        data-dismiss="modal"
                                                        onClick={() => this.cancelPayment()}
                                                    >
                                                        İptal Et
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <button
                                                        type="button"
                                                        className="btn btn-success rounded-pill px-4"
                                                        data-dismiss="modal"

                                                    >
                                                        Hayır
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterPaymentDetail">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(255, 170, 170)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }
}
function mapStateToProps(state) {
    return {
        payment: selectPayment(state)
    };
}
const mapDispatchToProps = dispatch => ({
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getPaymentList: (memberNo, startDate, endDate) => dispatch(getPaymentList(memberNo, startDate, endDate)),
    clearPaymentList: () => dispatch(clearPaymentList()),
    //getPaymentDetail: (memberNo, paymentId) => dispatch(getPaymentDetail(memberNo, paymentId)),
    deletePayment: (memberNo, paymentId, itemStartDate, startDate, endDate, isPayforPayment) => { dispatch(deletePayment(memberNo, paymentId, itemStartDate, startDate, endDate, isPayforPayment)) }
});
export default connect(mapStateToProps, mapDispatchToProps)(ListPayments);
